var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"float-right",attrs:{"variant":"outline-secondary","type":"button"},on:{"click":_vm.cancelAndGotoPreviuosPage}},[_vm._v(" Mégsem ")])}
var staticRenderFns = []

export { render, staticRenderFns }